(function (window, document) {
    /*
    * 适用于获取屏幕宽度等分设置 html 的 font-size 情况，比如 flexible.js 库
    */
    // 计算最终 html font-size
    function modifileRootRem() {
        var root = document.documentElement
        var fontSize = parseFloat(root.style.fontSize)
        var finalFontSize = parseFloat(window.getComputedStyle(root).getPropertyValue('font-size'))
        if (finalFontSize === fontSize) return
        root.style.fontSize = fontSize + (fontSize - finalFontSize) + 'px' // 【关键代码：差异补上】
    }
    if (typeof window.onload === 'function') {
        var oldFun = window.onload
        window.onload = function () {
            oldFun()
            modifileRootRem()
        }
    } else {
        window.onload = modifileRootRem
    }
})(window, document)